import { cn } from '../cn';
import { IconButton } from './IconButton';

export interface ChipProps {
  children: React.ReactNode;
  onRemove?: () => void;
  className?: string;
}

/** Removable mono chip (blocked words): 28 px, 10/6 padding, border2, radius 6, 500 11px; mobile 32 px / radius 8. */
export function Chip({ children, onRemove, className }: ChipProps) {
  return (
    <span className={cn('inline-flex h-8 items-center gap-2 rounded-lg border border-border2 pl-3 pr-2 font-mono text-base font-medium text-fg md:h-7 md:rounded md:pl-2.5 md:pr-1.5 md:text-sm', className)}>
      {children}
      {onRemove && (
        <IconButton framed={false} size="sm" label="Remove" onClick={onRemove} className="px-0.5 leading-none">
          ×
        </IconButton>
      )}
    </span>
  );
}
